// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"184":"e788bcfe","816":"b129e9f4","938":"e788bcfe"}[chunkId] + ".chunk.css";
};